import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-all',
  templateUrl: './stock-all.component.html',
  styleUrls: ['./stock-all.component.css']
})
export class StockAllComponent implements OnInit {
    stockKeyno;

    public itemsListStockAlls: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadStockAlls() {
        if (!!this.stockKeyno) {
            this.itemsListStockAlls = await this.datatask.Post(495, { stock_keyno: this.stockKeyno });
        }
    }

    private async init() {
        this.loadStockAlls();
    }

    ngOnInit() {
        this.init();
    }
}
